module.exports = __webpack_public_path__ + "static/media/21ECLAC4.15d30726.jpg";